import { AuthenticatedHttp } from '../../http/axios';
import { AppError, parsePaginationResponse } from '../../utils/api';

export const getCollaboratorsService = async ({ page, search, limit }) =>
  AuthenticatedHttp.get('/collaborators/', {
    params: {
      page,
      search,
      limit,
    },
  }).then(parsePaginationResponse);

export const createCollaboratorService = async ({ email, permissions }) =>
  AuthenticatedHttp.post('/collaborators/', {
    email,
    permissions,
  }).catch((error) => {
    throw new AppError(error);
  });

export const reinviteCollaboratorService = async (body) =>
  AuthenticatedHttp.post('/collaborators/', {
    email: body.user.email,
    permissions: body.permissions,
  }).catch((error) => {
    throw new AppError(error);
  });

export const updateCollaboratorService = async ({ id, ...data }) =>
  AuthenticatedHttp.put(`/collaborators/${id}/`, data).catch((error) => {
    throw new AppError(error);
  });

export const acceptCollaboratorService = async ({ id }) =>
  AuthenticatedHttp.post(`/collaborators/${id}/accept/`).catch((error) => {
    throw new AppError(error);
  });

export const rejectCollaboratorService = async ({ id }) =>
  AuthenticatedHttp.post(`/collaborators/${id}/reject/`).catch((error) => {
    throw new AppError(error);
  });

export const deleteCollaboratorService = async ({ id }) =>
  AuthenticatedHttp.delete(`/collaborators/${id}/`).catch((error) => {
    throw new AppError(error);
  });
